<template>
  <div>
    <model-table
      :collection="vouchers"
      :show-filter="displaySearch"
      :columns="!onlyVoucherPackages ? [
        { field: 'id' },
        { name: 'code', field: voucher => voucher.uid, classes: 'sensitive-column' },
        { field: 'user', component: 'model', filterDisabled: userId ? true : false, classes: 'sensitive-column' },
        { field: 'order', component: 'model', filterDisabled: true },
        { field: 'voucherType', component: 'model' },
        { name: 'state', field: 'stateIcon', component: 'icon' },
        { field: 'status', component: 'chip' },
        { field: 'cardNumber', classes: 'sensitive-column' },
        { name: 'createdAt', field: row => row.createdAt.i18n('timestamp'), component: 'date-time' },
        { name: 'redeemedAt', field: row => row.redeemedAt ? row.redeemedAt.i18n('timestamp') : null, component: 'date-time' },
        { name: 'expiresAt', field: row => row.expiresAt ? row.expiresAt.i18n('timestamp') : null, component: 'date-time' },
        { name: 'actions', label: 'Action', align: 'right' }
      ] : [
        { field: 'packageId' },
        { field: 'packageCode', classes: 'sensitive-column' },
        { field: 'voucherPackage', component: 'model' },
        { name: 'state', field: 'stateIcon', component: 'icon' },
        { field: 'order', component: 'model', filterDisabled: true },
        { field: 'status', component: 'chip' },
        { field: 'cardNumber', classes: 'sensitive-column' },
        { name: 'createdAt', field: row => row.createdAt.i18n('timestamp'), component: 'date-time' },
        { name: 'redeemedAt', field: row => row.redeemedAt ? row.redeemedAt.i18n('timestamp') : null, component: 'date-time' },
        { name: 'expiresAt', field: row => row.expiresAt ? row.expiresAt.i18n('timestamp') : null, component: 'date-time' },
        { name: 'actions', label: 'Action', align: 'right' }
      ]"
      add-label="Bulk Vouchers"
      :emit-only-add="true"
      @add="$refs.voucherBulkActivationDialog.show()"
    >
      <template #header-controls>
        <div class="q-mt-xs">
          <div class="row">
            <q-btn-toggle
              v-model="state"
              class="q-my-xs"
              size="sm"
              outline
              toggle-color="primary"
              :options="stateOptions"
            />
          </div>
          <div class="row">
            <q-btn-toggle
              v-model="filterBy"
              class="q-my-xs"
              size="sm"
              outline
              toggle-color="primary"
              :options="filterByOptions"
            />
          </div>
        </div>
      </template>
      <voucher-form />
    </model-table>
    <voucher-bulk-activation-dialog
      ref="voucherBulkActivationDialog"
    />
  </div>
</template>

<script>
import { FILTER_BY_TYPES } from 'src/models/voucher/Voucher'
import ModelTable from 'src/modules/admin/components/ModelTable'
import QueryEncodableOptionsMixin from 'src/modules/admin/mixins/QueryEncodableOptionsMixin'
import ShowingBadgesDisplayCell from 'src/modules/admin/showing-badge/components/ShowingBadgesDisplayCell'
import VoucherBulkActivationDialog from 'src/modules/admin/voucher/VoucherBulkActivationDialog'
import VoucherForm from 'src/modules/admin/voucher/VoucherForm'

export default {
  name: 'VoucherTable',
  components: {
    ModelTable,
    VoucherBulkActivationDialog,
    VoucherForm
  },
  mixins: [QueryEncodableOptionsMixin],
  models: {
    vouchers: {
      card: 'default',
      order: {
        fields: ['id']
      },
      user: {
        fields: ['id', 'firstName', 'lastName']
      },
      voucherType: 'default',
      issuedVoucherPackage: {
        card: 'default',
        voucherPackage: true
      },
      variables () {
        return {
          state: this.state,
          userId: this.userId,
          onlyUserVouchers: this.onlyUserVouchers,
          onlyCardVouchers: this.onlyCardVouchers,
          onlyVoucherPackages: this.onlyVoucherPackages
        }
      },
      immediate: false
    }
  },
  props: {
    userId: {
      type: Number,
      required: false,
      default: null
    },
    displaySearch: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      state: null,
      filterBy: null
    }
  },
  computed: {
    defaultQueryEncodableOptions () {
      return {
        state: null,
        filterBy: null
      }
    },
    onlyVoucherPackages () {
      return this.filterBy === FILTER_BY_TYPES.PACK
    },
    onlyCardVouchers () {
      return this.filterBy === FILTER_BY_TYPES.CARD
    },
    onlyUserVouchers () {
      return this.filterBy === FILTER_BY_TYPES.USER
    },
    filterByOptions () {
      return _.map(FILTER_BY_TYPES.ALL, type => {
        return { label: (type === FILTER_BY_TYPES.ANY ? '' : 'with ') + type, value: type }
      })
    },
    stateOptions () {
      return [
        { label: 'Valid', value: 'valid' },
        { label: 'Voided', value: 'voided' },
        { label: 'Redeemed', value: 'redeemed' },
        { label: 'Unused', value: 'unused' }
      ]
    }
  },
  created () {
    _.extend(this, { ShowingBadgesDisplayCell })
  },
  methods: {
    decodeUrlParamOption (key, value) {
      switch (key) {
        case 'filterBy':
          return _.includes(_.map(this.filterByOptions, 'value'), value) ? value : undefined
        case 'state':
          return _.includes(_.map(this.stateOptions, 'value'), value) ? value : undefined
        default:
          return undefined
      }
    }
  }
}
</script>
